import ctl from '@netlify/classnames-template-literals'
import { motion } from 'motion/react'
import { ReactNode } from 'react'

export interface WidgetWrapperProps {
	children: ReactNode
	hidden?: boolean
	padding?: boolean
}

export function WidgetWrapper({ children, hidden = false, padding = true }: WidgetWrapperProps) {
	if (hidden) {
		return null
	}

	return (
		<motion.div className="[contain:layout] text-xs bg-white/80 ring ring-grey-100 text-grey-700 text-center rounded-sm p-[3px] shadow w-full">
			<div className={ctl(`bg-white rounded-sm ring ring-grey-100 ${padding && 'p-2'}`)}>
				{children}
			</div>
		</motion.div>
	)
}
